var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", [_vm._v("Share")]),
    _vm._v(" "),
    _c("div", { staticClass: "c-article__share-btns" }, [
      _c("div", { staticClass: "inner" }, [
        _c(
          "a",
          {
            attrs: {
              href:
                "mailto:?subject=" +
                encodeURI(
                  _vm.communityName + " article on " + _vm.$root.brand.domain
                ) +
                "&body=" +
                encodeURI(
                  "I found this great " +
                    _vm.communityName +
                    " post on " +
                    _vm.$root.brand.domain +
                    " and I thought you might like to check it out:\n\n" +
                    _vm.title +
                    "\n" +
                    _vm.url
                ),
            },
            on: { click: _vm.closeMenu },
          },
          [
            _c("img", {
              attrs: {
                src: _vm.$cdn("/img/icons/icon-email-share-article.svg"),
                alt: "Share Article via Email",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.facebook.com/sharer/sharer.php?u=" +
                encodeURI(_vm.url),
              target: "_blank",
            },
            on: { click: _vm.closeMenu },
          },
          [
            _c("img", {
              attrs: {
                src: _vm.$cdn("/img/icons/icon-facebook-article.svg"),
                alt: "Share Article via Facebook",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://twitter.com/intent/tweet?url=" +
                encodeURI(_vm.url) +
                "&text=" +
                encodeURI(
                  "Read this great " +
                    _vm.communityName +
                    " post on " +
                    _vm.$root.brand.domain
                ),
              target: "_blank",
            },
            on: { click: _vm.closeMenu },
          },
          [
            _c("img", {
              attrs: {
                src: _vm.$cdn("/img/icons/icon-x-article.svg"),
                alt: "Share Article via X",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _vm.$simpleStore.isMobile
          ? _c(
              "a",
              {
                attrs: {
                  href: "https://wa.me/?text=" + encodeURI(_vm.url),
                  target: "_blank",
                },
                on: { click: _vm.closeMenu },
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.$cdn("/img/icons/icon-whatsapp-article.svg"),
                    alt: "Share Article via Whatsapp",
                  },
                }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }